import { ChevronDown } from 'lucide-react';

interface AccordionProps {
  children: React.ReactNode;
  title: string;
  defaultOpen?: boolean;
}

export const Accordion = ({ title, children, defaultOpen = false }: AccordionProps) => {
  return (
    <details className="group overflow-hidden" open={defaultOpen}>
      <summary className="flex items-center justify-between py-4 px-2 font-medium cursor-pointer list-none hover:bg-gray-50 transition-colors">
        <span>{title}</span>
        <ChevronDown className="h-4 w-4 transition-transform duration-200 group-open:rotate-180" />
      </summary>
      {children}
    </details>
  );
};
